export const SERVER_RESPONSE_WITH_ERROR = 'Server response with error';
export const DATA_IS_NOT_AVAILABLE = 'Data is not available';
export const NA = 'N/A';
